















































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import {
  Component, Vue, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { User } from '@/libs/api.interfaces';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Doughnut from '@/components/Chart/Doughnut.vue';
import Apex from '@/components/Chart/Apex.vue';
import Table from '@/components/Chart/Table.vue';
import Select from '@/components/Select.vue';
import Multiselect from 'vue-multiselect';
import vSelect from 'vue-select';

import Select2 from '@/components/Select2.vue';
import SearchField from '@/components/SearchField.vue';
import Bar from '@/components/Chart/Bar.vue';
import Box from '@/components/HomeBox.vue';
import FormInput from '@/components/FormInput.vue';
// import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import api from '@/libs/api';
// import apionepay from '@/libs/api';
import dayjs from 'dayjs';
import Loader from '@/components/Loader.vue';
import numberFormat from '@/libs/numberFormat';
import VueMonthlyPicker from 'vue-monthly-picker';
import CalendarIcon from '@/assets/calendar.svg';
import SandBox from '@/components/SandBoxHome.vue';
import Modal from '@/components/Modal.vue';
import FirstTime from '@/components/ModalContent/FirstTime.vue';
import PaymentMethod from '@/components/ModalContent/PaymentMethod.vue';
import InactiveUser from '@/components/InactiveUser.vue';

@Component({
  components: {
    SearchField,
    LayoutTitle,
    LayoutContent,
    Multiselect,
    Doughnut,
    Bar,
    VueMonthlyPicker,
    vSelect,
    Select,
    Box,
    // DatePicker,
    Loader,
    FormInput,
    CalendarIcon,
    Apex,
    Table,
    Select2,
    SandBox,
    Modal,
    FirstTime,
    PaymentMethod,
    InactiveUser,
  },
  methods: {
    numberFormat,
  },
  computed: mapState(['user']),
})
export default class OnepayDashboard extends Vue {
  user!: {
    user: User;
  };

  @Prop({ default: 'default' }) readonly size!: string;
  monthpick = false;
  // paymentDate: DateRange = {
  //   startDate: dayjs(dayjs().hour(0).minute(0).second(0)
  //     .subtract(1, 'day')).format('YYYY-MM-DD  00:00:00'),
  //   endDate: dayjs(dayjs().hour(0).minute(0).second(0)
  //     .subtract(1, 'day')).format('YYYY-MM-DD  23:59:59'),
  // }

  merchantLoginData: any = this.$store.state.user.user;
  userRole: any = this.merchantLoginData.user_role.role;

  env = process.env.VUE_APP_ENVIRONMENT;
  loading = true;
  loadingCard = false;
  loadingSummary = false;
  loadingChannel = false;
  loadingCustomer = false;
  loadingStatus = false;
  date = {
    from: null,
    to: null,
    month: null,
    year: null,
  }

  numberFormat!: typeof numberFormat;

  accountActive = true
  environment = process.env.VUE_APP_ENVIRONMENT || '';
  modalFirstTime = false;
  modalPayment = false

  datatrans = { value: 'TRANSACTION', label: 'Total Transaction' };
  customerBy = 'Browser';
  amountSuccess = '';
  transactionSuccess = '';
  amountChannel = [];
  amountData = [];
  amountOutstandingChannel = [];
  amountOutstandingData = [];
  amountOthers = '';
  trafficChannel = [];
  selectedAmount = [];
  selectedTraffic = [];
  selectedStatus: null | LabelValue = null;
  updateChart2 = [];
  trafficData = [];
  all = [];
  transactionsummary = [];
  widthchart = 1300;
  summaryparameter = {};
  transparameter = {};
  customerparameter = {};
  statustransparameter = {};

  selectedChannel: null | LabelValue = null;
  selectedBox: null | LabelValue = null;
  totalOutstanding = ''
  status: number[] = []
  summaryMonth = '';
  monthOutStanding = dayjs().format('YYYY-MM');
  currentdate = new Date();

  trafficperiode = '';
  trafficmonth = '';
  trafficyear = '';
  locale = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  series: any = [];
  labels: any = [];
  listDataSummary = [];
  listDataChannel = [];
  listDataCustomer = [];

  series4 = [
    {
      name: 'High - 2013',
      data: [28, 29, 33, 36, 32, 32, 33],
    },
    {
      name: 'Low - 2013',
      data: [12, 11, 14, 18, 17, 13, 13],
    },
  ];

  series1: any = [];
  chartOptions1: any = [];

  series2: any = [];
  chartOptions2: any = [];

  series3: any = [];
  chartOptions3: any = [];

  chartOptions4 = {
    chart: {
      height: 350,
      width: 1500,
      type: 'line',
      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2,
      },
      toolbar: {
        show: false,
      },
    },
    colors: ['#77B6EA', '#545454'],
    dataLabels: {
      enabled: true,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    title: {
      text: 'Average High & Low Temperature',
      align: 'left',
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    markers: {
      size: 1,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5,
    },
  };

  toggleModal() {
    this.modalFirstTime = !this.modalFirstTime;
    this.modalPayment = !this.modalPayment;
  }

  parseParams() {
    const params = this.$route.query;

    if (params.active === 'false') {
      this.accountActive = false;
    }

    if (params.boarding === 'true') {
      this.modalFirstTime = false;
    } else if (this.environment === 'sandbox') {
      this.modalFirstTime = true;
    }
  }

  close(value: boolean) {
    this.modalFirstTime = value;
  }

  dataTransaction = [
    { value: 'TRANSACTION', label: 'Total Transaction' },
    { value: 'REVENUE', label: 'Revenue' },
  ];

  listCustomerBy = ['Browser', 'Device'];

  channel1: any = [];

  // handleSearchChannelCode(search: string) {
  //   this.channelCodes = this.channel1.filter((e: any) => e.label.toLowerCase().includes(search));
  // }

  // onBlur() {
  //   this.channelCodes = this.channel1;
  // }

  getDataTrans() {
    this.getTransSummary();
    this.getTransPerChannel();
    this.getCustomerBy();
    this.getLineChart();
  }

  async getTransSummary() {
    /* eslint-disable @typescript-eslint/camelcase */
    try {
      this.loadingSummary = true;
      const periode = dayjs(this.trafficperiode.toString());

      this.summaryparameter = {
        traffic_month: periode.get('month') + 1,
        traffic_year: periode.get('year'),
        data_by: this.datatrans.value,
      };

      const { data } = await api.get('/onepay/home_trx_summary', {
        params: this.summaryparameter,
      });
      const transSummary = data.data.map((obj: any) => {
        let rObj = {};
        rObj = obj.y;
        return rObj;
      });
      this.series1 = transSummary;
      console.log('transSummary', transSummary);
      console.log('series1data', data);
      const labelSummary = data.data.map((obj: any) => {
        let rObj = {};
        rObj = obj.name;
        return rObj;
      });
      this.chartOptions1 = {
        dataLabels: {
          enabled: true,
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              show: false,
            },
          },
        }],
        legend: {
          position: 'bottom',
          offsetY: 0,
          height: 50,
        },
        labels: labelSummary,
      };
      this.loadingSummary = false;
    } catch (err) {
      console.error(err);
      this.loadingSummary = false;
    }
  }

  async getTransPerChannel() {
    /* eslint-disable @typescript-eslint/camelcase */
    try {
      this.loadingChannel = true;
      const periode = dayjs(this.trafficperiode.toString());

      this.transparameter = {
        traffic_month: periode.get('month') + 1,
        traffic_year: periode.get('year'),
        data_by: this.datatrans.value,
      };

      const { data } = await api.get('/onepay/home_trx_success_per_channel', {
        params: this.transparameter,
      });
      // this.chartOptions2 = {
      //   labels: data.data.map((val: any) => val.name),
      // };
      let seriesChannel = [];
      let labelChannel = [];
      if (data.data) {
        seriesChannel = data.data.map((obj: any) => {
          let rObj = {};
          rObj = obj.y;
          return rObj;
        });
        console.log('seriesChannel', seriesChannel);
        console.log('series2data', data);
        labelChannel = data.data.map((obj: any) => {
          let rObj = {};
          rObj = obj.name;
          return rObj;
        });
      }
      this.series2 = seriesChannel;
      this.chartOptions2 = {
        dataLabels: {
          enabled: true,
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              show: false,
            },
          },
        }],
        legend: {
          position: 'bottom',
          offsetY: 0,
          height: 50,
        },
        labels: labelChannel,
      };
      console.log('series2', this.series2);
      this.loadingChannel = false;
    } catch (err) {
      console.error(err);
      this.loadingChannel = false;
    }
  }

  async getCustomerBy() {
    /* eslint-disable @typescript-eslint/camelcase */
    try {
      this.loadingCustomer = true;
      const periode = dayjs(this.trafficperiode.toString());

      this.customerparameter = {
        traffic_month: periode.get('month') + 1,
        traffic_year: periode.get('year'),
        data_by: this.datatrans.value,
        method: this.customerBy,
      };

      const { data } = await api.get('/onepay/home_customer_user_agent', {
        params: this.customerparameter,
      });
      let seriesCustomer = [];
      let labelCustomer = [];
      if (data.data) {
        seriesCustomer = data.data.map((obj: any) => {
          let rObj = {};
          rObj = obj.y;
          return rObj;
        });
        console.log('seriesCustomer', seriesCustomer);
        labelCustomer = data.data.map((obj: any) => {
          let rObj = {};
          rObj = obj.name;
          return rObj;
        });
      }
      this.series3 = seriesCustomer;
      this.chartOptions3 = {
        dataLabels: {
          enabled: true,
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              show: false,
            },
          },
        }],
        legend: {
          position: 'bottom',
          offsetY: 0,
          height: 50,
        },
        labels: labelCustomer,
      };
      this.loadingCustomer = false;
    } catch (err) {
      console.error(err);
      this.loadingCustomer = false;
    }
  }

  async getLineChart() {
    /* eslint-disable @typescript-eslint/camelcase */
    try {
      this.loadingStatus = true;
      const periode = dayjs(this.trafficperiode.toString());

      this.statustransparameter = {
        traffic_month: periode.get('month') + 1,
        traffic_year: periode.get('year'),
        data_by: this.datatrans.value,
      };

      const { data } = await api.post('/onepay/home_trx_total_day',
        this.statustransparameter,
        {
          headers: { 'Content-Type': 'application/json' },
          auth: {
            username: 'operation',
            password: 'operation123',
          },
        });
      let listData: number[] = [];
      if (data.data) {
        this.series4 = data.data;
        console.log('series4data', data);
        data.data.forEach((val: any) => {
          listData = listData.concat(val.data);
        });
      }
      const maxData = Math.max(...listData);

      this.chartOptions4 = {
        ...this.chartOptions4,
        ...{
          xaxis: {
            categories: data.label,
            title: {
              text: 'Month',
            },
          },
          yaxis: {
            title: {
              text: 'Temperature',
            },
            min: 0,
            max: maxData + 5,
          },
        },
      };
      this.loadingStatus = false;
    } catch (err) {
      console.error(err);
      this.loadingStatus = false;
    }
  }

  /* eslint-disable class-methods-use-this */
  get chartWidth() {
    return window.screen.width <= 1366 ? '300' : '380';
  }

  @Watch('paymentDate.startDate')
  async chartDate() {
    this.customerBy = 'Browser';
    this.selectedChannel = null;
    // this.getChart();
  }

  // @Watch('monthOutStanding')
  // chartOutstandingDate() {
  //   this.getMonth();
  // }

  // @Watch('customerBy')
  // async updateChart() {
  //   this.getCard();
  // }

  mounted() {
    console.log('logindata', this.$store.state.user.user);
    this.trafficperiode = dayjs().toString();
    this.parseParams();
    this.getDataTrans();
  }
}
